import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./addform.module.css";
import { User } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-smart-toaster";
import NumberFormat from "react-number-format";
import VehiclePhotoPicker from "./VehiclePhotoPicker";

const PhoneField = (props) => {
  return (<NumberFormat prefix="" displayType="input" type="tel" format={"(###) ###-####"} {...props} />);
}

const phoneRegExp = /^\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/;

const schema = yup.object().shape({
  property_id: yup.string().required("This field is Required"),
  apt_id: yup.string(),
  tenant_id: yup.string(),
  tenant_info_id: yup.string().required("This field is Required"),
  license: yup.string().required("This field is Required"),
  make: yup.string().required("This field is Required"),
  model: yup.string().required("This field is Required"),
  color: yup.string().required("This field is Required"),
  is_guest: yup.boolean(),
  send_payment_link: yup.boolean(),
  guest_fname: yup.string().when("is_guest", {
    is: true,
    then: yup.string().required("This field is Required"),
    otherwise: yup.string(),
  }),
  guest_lname: yup.string().when("is_guest", {
    is: true,
    then: yup.string().required("This field is Required"),
    otherwise: yup.string(),
  }),
  guest_phone: yup.string().when("is_guest", {
    is: true,
    then: yup.string().required("This field is Required").matches(phoneRegExp, "Invalid phone number"),
    otherwise: yup.string(),
  }),
});

const VehicleAddForm = ({ setAddModalOpen, setLoading, setSnackbarMsg, setSnackbarOpen, onSubmitLocal }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [propertyList, setPropertyList] = useState([]);
  const [tenantList, setTenantList] = useState([]);
  const [photos, setPhotos] = useState([]);

  const { register, handleSubmit, control, errors, setValue, watch } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      property_id: "",
      apt_id: "",
      tenant_id: "",
      tenant_info_id: "",
      is_guest: false,
      send_payment_link: false,
      guest_fname: "",
      guest_lname: "",
      guest_phone: "",
    },
  });

  useEffect(() => {
    async function getProperties() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_TENANT_API_URL + "v1/property-list2", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setPropertyList(response.data.data);
      }).catch((error) => { });
    }
    getProperties();
  }, [getAccessTokenSilently]);

  const onSubmit = async (data) => {


    let formData = new FormData();

    formData.append("license", data?.license);
    formData.append("make", data?.make);
    formData.append("model", data?.model);
    formData.append("color", data?.color);
    formData.append("property_id", data?.property_id);
    formData.append("apt_id", data?.apt_id);
    formData.append("tenant_id", data?.tenant_id);

    if (data?.is_guest) {
      formData.append("is_guest", 1);
      formData.append("tenant_info_id", 0);
      formData.append("guest_fname", data?.guest_fname);
      formData.append("guest_lname", data?.guest_lname);
      formData.append("guest_phone", data?.guest_phone);
      formData.append("send_payment_link", data?.send_payment_link ? 1 : 0);
    } else {
      formData.append("is_guest", 0);
      formData.append("tenant_info_id", data?.tenant_info_id);
    }

    photos.forEach((photo) => { if (photo.file) formData.append("photos[]", photo.file); });

    setLoading(true);
    setAddModalOpen(false);

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    return axios
      .post(process.env.REACT_APP_TENANT_API_URL + "v1/vehicles", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLoading(false);

        setSnackbarOpen(true);
        setSnackbarMsg(response.data.message);

        const newVehicle = response.data.data;

        onSubmitLocal(response.data.data);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  }

  const isGuest = watch("is_guest");

  const onError = (error) => {
    console.log('error');
    console.log(error);
  }

  return (<div>
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <input type="hidden" ref={register} name="apt_id" />
      <input type="hidden" ref={register} name="tenant_id" />
      <div className={`${styles.ReqAddRow}`}>
        <div className={`${styles.ReqAddFormSec}`}>
          <Controller
            name="is_guest"
            control={control}
            render={(field) => (<FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);

                    setTenantList([]);
                    setValue("property_id", "");
                    setValue("tenant_info_id", "");
                  }}
                />
              }
              label="Guest vehicle"
              className="CustomCheckBox"
            />)}
          />

          {!isGuest ? (<div className={`${styles.FormSecRow}`}>
            <div className={`${styles.FormHalfSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                    <Controller
                      name="property_id"
                      control={control}
                      render={(field) => (<Select
                        {...field}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Property"
                        onChange={(e) => {
                          field.onChange(e);

                          if (e.target.value) {
                            let selectedProperty = propertyList?.filter((i) => i?.id === e.target.value);
                            if (selectedProperty?.length > 0) {
                              selectedProperty = selectedProperty[0];

                              let tenantList = selectedProperty?.tenants2?.map((i) => {
                                return { id: i?.id, name: i?.first_name + " " + i?.last_name, apt_id: i?.apt_id, tenant_id: i?.tenant_id, apt_no: i?.apt_no };
                              });

                              setTenantList(tenantList);
                            }
                          } else {
                            setTenantList([]);
                          }

                          setValue("tenant_info_id", "");
                        }}
                      >
                        {propertyList?.map((item) => {
                          return (<MenuItem value={item.id} disabled={item?.tenants2?.length === 0}>{item.name}</MenuItem>);
                        })}
                      </Select>)}
                    />
                  </FormControl>
                  {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors?.property_id?.message}</p>)}
                </div>
              </div>
            </div>
            <div className={`${styles.FormHalfSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name="tenant_info_id"
                    control={control}
                    render={(field) => (<Autocomplete
                      options={tenantList}
                      getOptionLabel={(option) => option.name || ""}
                      getOptionDisabled={(option) => option?.has_guest_vehicle === 1}
                      noOptionsText={(tenantList.length === 0 ? "Select Property First" : "No Tenants Available")}
                      isOptionEqualToValue={(option, value) => option.id === (value?.id ?? value)}
                      value={tenantList.find((t) => t.id === field.value) || null}
                      onChange={(_, selected) => {
                        if (selected && !selected?.has_guest_vehicle) {
                          field.onChange(selected.id);
                          setValue("apt_id", selected.apt_id);
                          setValue("tenant_id", selected.tenant_id?.toString());
                        } else {
                          field.onChange("");
                          setValue("apt_id", "");
                          setValue("tenant_id", "");
                        }
                      }}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          <div style={{ display: "flex", flexDirection: "column", padding: "2px 0" }}>
                            <span style={{ fontSize: "14px", color: "inherit" }}>{option.name}</span>
                            {option.apt_id && (<span style={{ fontSize: "11px", color: "rgba(0,0,0,0.45)", marginTop: "2px" }}>{option.apt_no}{option?.has_guest_vehicle ? " · Already has a guest vehicle" : ""}</span>)}
                          </div>
                        </li>
                      )}
                      renderInput={(params) => (<TextField {...params} label="Tenant*" variant="outlined" placeholder={tenantList.length === 0 ? "Select Property First" : "Search tenant..."} />)}
                    />)}
                  />
                  {errors.tenant_info_id && (<p className={`${styles.ErrorM}`}>{errors?.tenant_info_id?.message}</p>)}
                </div>
              </div>
            </div>
          </div>) : (<div className={styles.GuestDetailsFormCard}>
            <div className={styles.GuestDetailsFormHeader}>
              <User size={16} className={styles.GuestFormIcon} />
              <span>Guest details</span>
            </div>

            <div className={`${styles.FormSecRow}`}>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name="guest_fname"
                      control={control}
                      render={(field) => (<TextField {...field} label="First Name*" variant="outlined" fullWidth />)}
                    />
                    {errors.guest_fname && (<p className={`${styles.ErrorM}`}>{errors?.guest_fname?.message}</p>)}
                  </div>
                </div>
              </div>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name="guest_lname"
                      control={control}
                      render={(field) => (<TextField {...field} label="Last Name*" variant="outlined" fullWidth />)}
                    />
                    {errors.guest_lname && (<p className={`${styles.ErrorM}`}>{errors?.guest_lname?.message}</p>)}
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.FormSecRow}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name="guest_phone"
                    control={control}
                    render={(field) => (<TextField {...field} label="Phone number*" variant="outlined" fullWidth InputProps={{ inputComponent: PhoneField }} />
                    )}
                  />
                  {errors.guest_phone && (<p className={`${styles.ErrorM}`}>{errors?.guest_phone?.message}</p>)}
                </div>
              </div>
            </div>

            <div className={`${styles.FormSecRow}`}>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Visiting property*</InputLabel>
                      <Controller
                        name="property_id"
                        control={control}
                        render={(field) => (<Select
                          {...field}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Visiting property*"
                          onChange={(e) => {
                            field.onChange(e);

                            if (e.target.value) {
                              let selectedProperty = propertyList?.filter((i) => i?.id === e.target.value);
                              if (selectedProperty?.length > 0) {
                                selectedProperty = selectedProperty[0];

                                const uniqueTenants = selectedProperty?.tenants2?.filter(
                                  (item, index, self) =>
                                    index === self.findIndex((t) => t.apt_id === item.apt_id)
                                ).map((i) => ({
                                  id: i?.id,
                                  name: i?.first_name + " " + i?.last_name,
                                  apt_id: i?.apt_id,
                                  tenant_id: i?.tenant_id,
                                  apt_no: i?.apt_no,
                                  has_guest_vehicle: i?.has_guest_vehicle
                                }));

                                setTenantList(uniqueTenants);
                              }
                            } else {
                              setTenantList([]);
                            }

                            setValue("tenant_info_id", "");
                          }}
                        >
                          {propertyList?.map((item) => {
                            return (<MenuItem value={item.id} disabled={item?.tenants2?.length === 0}>{item.name}</MenuItem>);
                          })}
                        </Select>)}
                      />
                    </FormControl>
                    {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors?.property_id?.message}</p>)}
                  </div>
                </div>
              </div>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name="tenant_info_id"
                      control={control}
                      render={(field) => (<Autocomplete
                        options={tenantList}
                        getOptionLabel={(option) => option.name || ""}
                        getOptionDisabled={(option) => !!option?.has_guest_vehicle}
                        noOptionsText={(tenantList.length === 0 ? "Select Property First" : "No Tenants Available")}
                        isOptionEqualToValue={(option, value) => option.id === (value?.id ?? value)}
                        value={tenantList.find((t) => t.id === field.value) || null}
                        onChange={(_, selected) => {
                          if (selected && !selected?.has_guest_vehicle) {
                            field.onChange(selected.id);
                            setValue("apt_id", selected.apt_id);
                            setValue("tenant_id", selected.tenant_id?.toString());
                          } else {
                            field.onChange("");
                            setValue("apt_id", "");
                            setValue("tenant_id", "");
                          }
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            <div style={{ display: "flex", flexDirection: "column", padding: "2px 0" }}>
                              <span style={{ fontSize: "14px", color: "inherit" }}>{option.name}</span>
                              {option.apt_id && (<span style={{ fontSize: "11px", color: "rgba(0,0,0,0.45)", marginTop: "2px" }}>{option.apt_no}{option?.has_guest_vehicle ? " · Already has a guest vehicle" : ""}</span>)}
                            </div>
                          </li>
                        )}
                        renderInput={(params) => (<TextField {...params} label="Visiting tenant*" variant="outlined" placeholder={tenantList.length === 0 ? "Select Property First" : "Search tenant..."} />)}
                      />)}
                    />
                    {errors.tenant_info_id && (<p className={`${styles.ErrorM}`}>{errors?.tenant_info_id?.message}</p>)}
                  </div>
                </div>
              </div>
            </div>
          </div>)}

          <div className={`${styles.FormSecRow}`}>
            <div className={`${styles.FormHalfSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name={`license`}
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Vehicle License*" variant="outlined" />)}
                  />
                  {errors.license && (<p className={`${styles.ErrorM}`}>{errors?.license?.message}</p>)}
                </div>
              </div>
            </div>
            <div className={`${styles.FormHalfSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name={`make`}
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Make*" variant="outlined" />)}
                  />
                  {errors.make && (<p className={`${styles.ErrorM}`}>{errors?.make?.message}</p>)}
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.FormSecRow}`}>
            <div className={`${styles.FormHalfSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name={`model`}
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Model*" variant="outlined" />)}
                  />
                  {errors.model && (<p className={`${styles.ErrorM}`}>{errors?.model?.message}</p>)}
                </div>
              </div>
            </div>
            <div className={`${styles.FormHalfSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name={`color`}
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Color*" variant="outlined" />)}
                  />
                  {errors.color && (<p className={`${styles.ErrorM}`}>{errors?.color?.message}</p>)}
                </div>
              </div>
            </div>
          </div>

          {isGuest && (<div className={`${styles.GuestDetailsFormCard} ${styles.FeeSec}`}>
            <Controller
              name="send_payment_link"
              control={control}
              render={(field) => (<FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label="Send a parking payment link to the guest's phone number"
                className="CustomCheckBox"
              />)}
            />
            <p className={`${styles.GuestFeeCHeckText}`}>The guest will receive an SMS with a secure payment link to choose and pay for their parking pass (Day or Monthly). Once paid, they are texted a secure link to open the parking gate and door.</p>
          </div>)}

          <VehiclePhotoPicker photos={photos} onChange={setPhotos} inputId="add-vehicle-photos" />
        </div>
      </div>
      <div className={`${styles.ButtonAction}`}>
        <Button onClick={(e) => setAddModalOpen(false)} className="CancelPopupBU">Cancel</Button>
        <Button type="submit" className="SubmitPopupBU">Add</Button>
      </div>
    </form>
  </div>);
};

export default VehicleAddForm;